<template>
  <div class="">
    <div class="counter h5">
      {{  cntCharTextArea + '/500' }}
    </div>
    <div class="flex textarea-box textarea-wrapper center-xs">
      <base-textarea
        v-if="partnerCode === 'gift'"
        type="text"
        class="textarea-custom textarea-custom-for-gift"
        :class="{'validation' : $v.orderComment.$error && !$v.orderComment.required}"
        :placeholder="$t('Recipient\'s data: name, phone number, comment on the order *')"
        v-model="orderComment"
        @blur="$v.orderComment.$touch()"
        :validations="[
          {
            condition: $v.orderComment.$error && !$v.orderComment.required,
            text: $t('Field is required')
          }
        ]"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseTextarea from "../Form/BaseTextarea";
import { required } from 'vuelidate/lib/validators'
export default {
  props: {
    partnerCode: {
      type: [String],
      required: true
    }
  },
  components: {
    BaseTextarea
  },

  data () {
    return {
      orderComment: '',
      placeholderText: 'Specify additional information for picker. For example: "The door code is 111" or "If you run out of red tomatoes, take the yellow tomatoes"'
    }
  },
  watch: {
    orderComment: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    }
  },
  computed: {
    ...mapGetters({
      getComments: 'checkout/getComments'
    }),

    cntCharTextArea () {
      return this.orderComment.length
    }
  },
  mounted () {
    let comments = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/comment'));
    if (comments) {
      let comment = comments.find(c => c.partner === this.partnerCode)
      if (comment) {
        this.orderComment = comment.comment
      }
    }
  },
  validations: {
    orderComment:{
      required
    }
  },
  methods: {
    changePlaceholder () {
      this.$refs.comment.placeholder = this.$t(this.placeholderText);
    },

    sendDataToCheckout () {
      this.$bus.$emit(
        'checkout-after-comment',
        this.orderComment,
        this.partnerCode
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  ::placeholder {
    color: #bdbdbd;
    font-family: "TTNorms Regular", serif;
  }
  .counter {
    margin-left: 2px;
  }
  .textarea-custom {
    width: 100%;
    resize: none;
    border: 1px solid #cecdcd;
    border-radius: 10px;
    padding: 10px;
    @media (max-width: 500px) {
      padding-top: 30px;
    }
  }
  .validation {
    border-color: #eb5757;
  }
</style>
<style lang="scss">
  .textarea-custom-for-gift {
    max-height: 52px;
    textarea {
      border: none!important;
      min-height: 55px;
      margin-top: 0;
    }
    label {
      @media (max-width: 500px) {
        top: -10px;
      }
    }
    textarea:focus ~ label, textarea:not(.empty) ~ label {
      @media (max-width: 500px) {
        top: -27px;
      }
    }
  }
</style>
